import { CSSProgressiveCaption01 } from "@caisy/league";
import styled from "styled-components";

export const SOnboardingAssetFieldDescription = styled.div`
  ${CSSProgressiveCaption01};
  color: var(--text-04);
`;
